import React, { useContext, useState } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp';
import { Box, Flex } from 'rebass';

import FormButton from '../../../components/FormButton/FormButton';
import FormInput from '../../../components/FormInput/FormInput';
import Typography from '../../../components/Typography/Typography';
import { TypographyContext } from '../../../components/Typography/config';

export const NewsletterSignup = () => {
  const { colourScheme } = useContext(TypographyContext);
  const [email, setEmail] = useState('');
  const [mailChimpResult, setMailChimpResult] = useState(null);

  const handleMailchimpSignupSubmit = async (e) => {
    e.preventDefault();
    const result = await addToMailchimp(email, {
      source: window.location.pathname,
    });
    setMailChimpResult(result);
    window.dataLayer?.push?.({
      newsletterSignupResult: result.result,
      event: 'newsletterSignup',
    });
  };
  return (
    <>
      <Flex as="form" width="100%" maxWidth={['300px', , '400px']}>
        <Box flexGrow="2">
          <FormInput
            width="100%"
            placeholder="Email..."
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              fontFamily: 'FoundersGrotesk, sans-serif',
              fontWeight: 'normal',
            }}
          />
        </Box>
        <Box>
          <FormButton
            colourScheme={colourScheme}
            onClick={(e) => {
              handleMailchimpSignupSubmit(e);
            }}
            grouped
          >
            <Typography inline>Sign Up</Typography>
          </FormButton>
        </Box>
      </Flex>
      {mailChimpResult && (
        <Typography
          color={mailChimpResult.result === 'error' && theme.colors.red}
          maxWidth="24em"
          mt={[3, , 4]}
          variant="body-small"
        >
          {mailChimpResult.msg}
        </Typography>
      )}
    </>
  );
};

export default NewsletterSignup;
